const Menudata =[
    {
        id: 1,
        title: 'Home',
        href: '#Home'
    },
    {
        id: 2,
        title: 'About',
        href: '#About'
    },
    {
        id: 3,
        title: 'Skills',
        href: '#skills'
    },
    {
        id: 4,
        title: 'My Interests',
        href: '#interest'
    },
    {
        id: 5,
        title: 'Service',
        href: '#service'
    },
    {
        id: 6,
        title: 'Resumes',
        href: '#resumes'
    },
    {
        id: 7,
        title: 'Project',
        href: '#project'
    },
    {
        id: 8,
        title: 'Contact Us',
        href: '#contact'
    }  
]

export default Menudata
